// @flow
import env from '../../environment';
import {getCreator, putCreator} from '../../http';

export const endpoints = Object.freeze({
  LIST_PRODUCTS: `${env.baseApiUrl}/winehouse/admin/product`,
  SORT_PRODUCT: `${env.baseApiUrl}/im/admin/product/:id/number`,
});

export type ProductVariantsRequest = {
  options: {name: string, values: string[]}[],
  variants: {
    imageId?: string | number,
    options: {[key: string]: string},
    price: string,
    offerPrice?: string,
    enabledBulkPrice: boolean,
    stock?: number,
    sku?: string,
    enabled: boolean,
  }[],
};

export const listProductsApi = getCreator(endpoints.LIST_PRODUCTS);
export const sortProductApi = putCreator(endpoints.SORT_PRODUCT);
